import React from 'react';
import { Result, Button } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import DashboardLayout from './components/DashboardLayout';

const NotFound: React.FC = () => {
  const location = useLocation();
  const role = localStorage.getItem('role') || '';
  
  const getHomePath = () => {
    switch (role) {
      case 'Admin':
        return '/v1/admin/dashboard';
      case 'Recruiter':
        return '/v1/recruiter/dashboard';
      case 'Employee':
        return '/v1/employee/dashboard';
      case 'Candidate':
        return '/v1/candidate/dashboard';
      default:
        return '/';
    }
  };

  const isDashboardRoute = location.pathname.startsWith('/v1/');

  if (isDashboardRoute) {
    return (
      <DashboardLayout>
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Link to={getHomePath()}>
              <Button type="primary" icon={<HomeOutlined />} size="large">
                Back to Dashboard
              </Button>
            </Link>
          }
        />
      </DashboardLayout>
    );
  }

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f0f2f5'
    }}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Link to="/">
            <Button type="primary" icon={<HomeOutlined />} size="large">
              Back Home
            </Button>
          </Link>
        }
      />
    </div>
  );
};

export default NotFound;